import React, { useState, useEffect } from 'react';
import '../styles/AuthPage.css';
import '../styles/AdminPage.css';

const AdminPage = () => {
    const [email, setEmail] = useState('');
    const [isAdmin, setIsAdmin] = useState(false);
    const [message, setMessage] = useState('');
    const [users, setUsers] = useState([]);

    const fetchUsers = async () => {
        const token = localStorage.getItem('accessToken');
        if (!token) {
            setMessage('You are not logged in.');
            return;
        }
        try {
            const response = await fetch('/api/admin/users', {
                headers: { 'Authorization': `Bearer ${token}` }
            });
            if (response.ok) {
                const data = await response.json();
                setUsers(data);
            } else {
                setMessage('Failed to fetch users.');
            }
        } catch (error) {
            setMessage('An error occurred while fetching users.');
        }
    };

    useEffect(() => {
        fetchUsers();
    }, []);

    const handleCreateUser = async (e) => {
        e.preventDefault();
        setMessage('');

        const token = localStorage.getItem('accessToken');
        if (!token) {
            setMessage('You are not logged in.');
            return;
        }

        try {
            const response = await fetch('/api/admin/create_user', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`
                },
                body: JSON.stringify({ email, is_admin: isAdmin }),
            });

            const data = await response.json();

            if (response.ok) {
                setMessage(data.msg);
                setEmail('');
                setIsAdmin(false);
                fetchUsers(); // Refresh the user list
            } else {
                setMessage(data.msg || 'Failed to create user.');
            }
        } catch (error) {
            setMessage('An error occurred.');
            console.error('Create user error:', error);
        }
    };

    const handleDeactivateUser = async (userId) => {
        const token = localStorage.getItem('accessToken');
        if (!token) {
            setMessage('You are not logged in.');
            return;
        }

        try {
            const response = await fetch(`/api/admin/users/${userId}/deactivate`, {
                method: 'POST',
                headers: {
                    'Authorization': `Bearer ${token}`
                }
            });

            if (response.ok) {
                const data = await response.json();
                setMessage(data.msg);
                fetchUsers(); // Refresh the user list
            } else {
                const errorData = await response.json();
                setMessage(errorData.msg || 'Failed to deactivate user.');
            }
        } catch (error) {
            setMessage('An error occurred during deactivation.');
            console.error('Deactivation error:', error);
        }
    };

    return (
        <div className="auth-page">
            <div className="auth-container">
                <div className="auth-header">
                    <h2 className="auth-title">Admin - Create New User</h2>
                </div>
                <form onSubmit={handleCreateUser} className="auth-form">
                    <div className="form-group">
                        <label>Email</label>
                        <input
                            type="email"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            required
                        />
                    </div>
                    <div className="form-group">
                        <label className="checkbox-label">
                            <input
                                type="checkbox"
                                checked={isAdmin}
                                onChange={(e) => setIsAdmin(e.target.checked)}
                            />
                            Assign Admin Privileges
                        </label>
                    </div>
                    <button type="submit" className="auth-button">Create User</button>
                </form>
                {message && <p className="auth-message">{message}</p>}
            </div>

            <div className="user-table-container">
                <h2 className="user-table-title">Existing Users</h2>
                <table className="user-table">
                    <thead>
                        <tr>
                            <th>Email</th>
                            <th>Admin</th>
                            <th>Active</th>
                            <th>Last Login</th>
                            <th>Actions</th>
                        </tr>
                    </thead>
                    <tbody>
                        {users.map(user => (
                            <tr key={user.id}>
                                <td>{user.email}</td>
                                <td>{user.is_admin ? 'Yes' : 'No'}</td>
                                <td>{user.is_active ? 'Yes' : 'No'}</td>
                                <td>{user.last_login ? new Date(user.last_login).toLocaleString() : 'N/A'}</td>
                                <td>
                                    <button 
                                        onClick={() => handleDeactivateUser(user.id)}
                                        className="deactivate-button"
                                        disabled={!user.is_active}
                                    >
                                        Deactivate
                                    </button>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </div>
    );
};

export default AdminPage;
